import { BUTTON_BACK, BUTTON_NEXT } from './FilesPreviewGallery.constants'

export function isButtonBack(type) {
  return type === BUTTON_BACK
}

export function isButtonNext(type) {
  return type === BUTTON_NEXT
}
